<template>
  <div class="show-project">
    <div v-if="isEmployee">
      <ProjectDetail />
    </div>
    <div v-else-if="isCustomer">
      <CustomerProjectDetail />
    </div>
  </div>
</template>

<script lang="ts" setup>
import ProjectDetail from '../components/ProjectDetail.vue'
import CustomerProjectDetail from '../components/CustomerProjectDetail.vue'
import { useAuth } from '@/composables/useAuth'

const { isEmployee, isCustomer } = useAuth()
</script>
